import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getGroupsViewStyles = (theme: Theme, windowWidth = 390) => {
  const wcWebMaxWidth = Platform.OS === 'web'
    ? (windowWidth >= 1024 ? 880 : windowWidth >= 768 ? 700 : 560)
    : undefined;

  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    scrollContent: {
      paddingBottom: 120,
      paddingTop: 24,
      paddingHorizontal: 20,
      ...(wcWebMaxWidth != null && {
        maxWidth: wcWebMaxWidth,
        width: '100%' as never,
        alignSelf: 'center' as const,
      }),
    },
    pageTitle: {
      fontSize: 28,
      fontWeight: '900',
      color: theme.black,
      letterSpacing: -0.5,
      marginBottom: 16,
    },
    ctaRow: {
      flexDirection: 'row',
      gap: 12,
      marginBottom: 28,
    },
    ctaButton: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      paddingVertical: 16,
      paddingHorizontal: 12,
      borderRadius: theme.borderRadius.xl,
      minHeight: 52,
    },
    ctaButtonCreate: {
      backgroundColor: theme.primary,
      ...(Platform.OS === 'web' && {
        boxShadow: theme.shadows.button,
      }),
      ...(Platform.OS !== 'web' && {
        shadowColor: theme.primary,
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.22,
        shadowRadius: 8,
        elevation: 5,
      }),
    },
    ctaButtonJoin: {
      backgroundColor: theme.secondary,
      ...(Platform.OS === 'web' && {
        boxShadow: `0 4px 14px ${theme.secondary}55` as never,
      }),
      ...(Platform.OS !== 'web' && {
        shadowColor: theme.secondary,
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.35,
        shadowRadius: 8,
        elevation: 5,
      }),
    },
    ctaButtonPressed: { opacity: 0.92 },
    ctaButtonHover: { opacity: 0.96 },
    ctaButtonTextCreate: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.onPrimary,
      textAlign: 'center',
      flexShrink: 1,
    },
    ctaButtonTextJoin: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.textOnStatusBadge,
      textAlign: 'center',
      flexShrink: 1,
    },
    discoverySection: {
      marginTop: 12,
      marginBottom: 8,
      borderRadius: 24,
      paddingVertical: 28,
      paddingHorizontal: 22,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    discoveryGradientFill: {
      ...StyleSheet.absoluteFillObject,
    },
    discoveryInner: {
      alignItems: 'center',
      gap: 8,
      zIndex: 1,
    },
    discoveryTitle: {
      fontSize: 20,
      fontWeight: '900',
      color: theme.primary,
      textAlign: 'center',
      letterSpacing: -0.3,
    },
    discoverySubtitle: {
      fontSize: 14,
      color: theme.gray[500],
      textAlign: 'center',
      lineHeight: 20,
      maxWidth: 280,
    },
    discoveryCta: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      marginTop: 8,
      paddingVertical: 8,
      paddingHorizontal: 4,
    },
    discoveryCtaPressed: { opacity: 0.75 },
    discoveryCtaHover: { opacity: 0.9 },
    discoveryCtaText: {
      fontSize: 11,
      fontWeight: '800',
      color: theme.primary,
      textTransform: 'uppercase',
      letterSpacing: 1.4,
    },
    emptyState: {
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingTop: 32,
      paddingBottom: 16,
    },
    emptyEmoji: {
      fontSize: 48,
      marginBottom: 12,
    },
    emptyTitle: {
      fontSize: 18,
      fontWeight: '800',
      color: theme.black,
      marginBottom: 8,
    },
    emptySubtitle: {
      fontSize: 14,
      color: theme.gray[500],
      textAlign: 'center',
      lineHeight: 20,
    },
  });
};
